import splide from '@splidejs/splide';

export default function() {
	let testimonials: HTMLElement|null = document.querySelector('.testimonials__wrapper--carousel');
	if (!testimonials) return;
	new splide(testimonials, {
		rewind     : false,
		arrows     : true,
		pagination : false,
		drag: true,
		perPage: 2,
		gap: 0,
		breakpoints: {
			1024: {
				perPage: 2,
			},
			768: {
				perPage: 1,
			}
		}
	}).mount();
}